/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
/* -*- JS -*- */
// ------------------------------------------------------------------------
//
// This code is property of BioSilico Limited and is protected by
// copyright law and international treaties. Unauthorized
// reproduction or distribution of this file, or any portion of
// it may result in severe civil and criminal penalties, and will
// be prosecuted to the maximum extent possible under the law.
//
// = LIBRARY
//   HomepageJS
//
// = FILENAME
//   LoginComponent.jsx
//
// = AUTHOR
//   Who       When        Why/What
//   K. Plewa   09.11.2022  Development
//
// ------------------------------------------------------------------------

import React, { useState, useEffect } from "react";
import "./LoginComponent.css";
import exchangeToken from "../../resources/exchangeToken";
import "@aws-amplify/ui-react/styles.css";
import LogInWithClassLink from "../../images/LogInWithClasslinkNew.png";
import LogInWithClever from "../../images/LogInWithCleverNew.png";
import IdeaMapperLogoWhite from "../../images/IdeaMapperWhiteTitle.svg";
import IdeaMapperLogo from "../../images/IdeaMapperLogo.svg";
import AuthenticatorComponent from "./AuthenticatorComponent";
import RotatingMessages from "./RotatingMessages";
import { CheckboxField } from "@aws-amplify/ui-react";
import { isFirefox } from "mobile-device-detect";
import $ from "jquery";
import Cookie from "js-cookie";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import { ageEnum, supportLinks } from "../../resources/enums";
import GoogleLoginButton from "./GoogleCustomLoginButton";
import AzureAuthenticatorComponent from "./MSAzureLoginComponent";

const LoginComponent = (props) => {
  const [hasChecked, setHasChecked] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [validAge, setValidAge] = useState(ageEnum.unknown);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showOtherProviders, setShowOtherProviders] = useState(false);
  const [showHide, setShowHide] = useState(false);
  const [isFirstTimeLogin, setFristTimeLogin] = useState(true);

  // ------------------------------------------------------------------------
  useEffect(() => {
    // Need to reverse the logic as localStorage will return null
    // which in JS is "falsy" so it will display "Welcome back!"
    let checkloginTime = localStorage.getItem("isFirstTimeLogin");
    if (
      checkloginTime === false ||
      checkloginTime === undefined ||
      checkloginTime === null
    ) {
      setFristTimeLogin(true);
    } else if (checkloginTime === true) {
      setFristTimeLogin(false);
    }
    const tempCookie = Cookie.get("agreedToPolicies");
    if (tempCookie === "true") {
      setHasChecked(true);
      setHasError(false);
    } else {
      setHasChecked(false);
      setHasError(true);
    }
    const isValidAge = Cookie.get("ageVerified");
    if (isValidAge === undefined) {
      setValidAge(ageEnum.unknown);
    } else {
      setValidAge(isValidAge);
    }
    async function verifyTokenAndProceed() {
      const verifyToken = sessionStorage.getItem("userServiceAccessToken");
      if (verifyToken) {
        try {
          const haveVerified = await props.checkExistingToken(verifyToken);
          if (haveVerified) {
            sessionStorage.setItem("otherProvider", true);
            window.saveDataForWASM(
              "google",
              "googleIdTokenString",
              "googleAccessTokenString",
              verifyToken
            );
            props.setShowSignInPage(false);
            return;
          } else {
            setShowHide(true);
            return;
          }
        } catch (error) {
          // Handle any errors that occur during the verification process
          console.error("Error verifying token:", error);
          return;
        }
      } else {
        setShowHide(true);
      }
    }
    async function checkPoliciesVersion() {
      const userAgreements = JSON.parse(
        sessionStorage.getItem("UserAgreements")
      );

      userAgreements.forEach((e) => {
        if (e.Platforms.includes("W")) {
          if (!Cookie.get(e.Name)) {
            Cookie.set(e.Name, e.Version);
            handleCheckedChange(false);
          } else {
            let cookieVersion = Cookie.get(e.Name);
            if (cookieVersion !== e.Version) {
              Cookie.set(e.Name, e.Version);
              handleCheckedChange(false);
            }
          }
        }
      });
    }
    checkPoliciesVersion();
    verifyTokenAndProceed();
  }, []);

  // ------------------------------------------------------------------------
  useEffect(() => {
    manageDisabledLogInTooltip();

    // Clean up event listeners
    return () => {
      const disabledDiv = document.querySelector(".disabled-div");
      if (disabledDiv) {
        disabledDiv.removeEventListener("mouseover", handleMouseOver);
        disabledDiv.removeEventListener("mouseout", handleMouseOut);
      }
    };
  }, [hasError, hasChecked]);

  // ------------------------------------------------------------------------
  const manageDisabledLogInTooltip = () => {
    const disabledDiv = document.querySelector(".disabled-div");
    if (disabledDiv) {
      disabledDiv.addEventListener("mouseover", handleMouseOver);
      disabledDiv.addEventListener("mouseout", handleMouseOut);
    }
  };

  // ------------------------------------------------------------------------
  const handleMouseOver = () => {
    const myDiv = document.getElementById("disabled");
    if (myDiv) {
      const disabledDiv = document.querySelector(".disabled-div");
      if (disabledDiv) {
        myDiv.title = "Please accept the terms below to proceed.";
      } else {
        myDiv.title = "";
      }
    }
  };

  // ------------------------------------------------------------------------
  const handleMouseOut = () => {
    const myDiv = document.getElementById("disabled");
    if (myDiv) {
      myDiv.title = "";
    }
  };

  // ------------------------------------------------------------------------
  // Exhange AWS Cognito token for Ideamapper token
  const onCognitoSuccess = async (idToken) => {
    // Do await and catch errors within the await to get most data and
    // allow for better error handling depending on error
    const { userServiceToken } = await exchangeToken(
      idToken.signInUserSession.idToken.jwtToken,
      "cognito"
    ).catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
      console.log(error.config);
    });
    if (userServiceToken !== null && userServiceToken !== undefined) {
      Cookie.set("agreedToPolicies", true, { expires: 365 });
      window.saveDataForWASM(
        "cognito",
        idToken.signInUserSession.idToken.jwtToken,
        "cognitoAccessTokenString",
        userServiceToken
      );
      localStorage.setItem("isFirstTimeLogin", false);
      props.setShowSignInPage(false);
    }
  };

  // ------------------------------------------------------------------------
  // Google Token exchange function after user identified themselves
  const onGoogleSuccess = async (credentialResponse) => {
    const { userServiceToken } = await exchangeToken(
      credentialResponse.access_token,
      "google"
    ).catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log(`Error ${error}`);
      }
      console.log(`Error ${error}`);
    });
    if (userServiceToken !== null && userServiceToken !== undefined) {
      sessionStorage.setItem("otherProvider", true);
      Cookie.set("agreedToPolicies", true, { expires: 365 });
      sessionStorage.setItem("userServiceAccessToken", userServiceToken);
      window.saveDataForWASM(
        "google",
        "googleIdTokenString",
        credentialResponse.access_token,
        userServiceToken
      );
      localStorage.setItem("isFirstTimeLogin", false);
      props.setShowSignInPage(false);
    }
  };

  // ------------------------------------------------------------------------
  // Exhange AWS Cognito token for Ideamapper token
  const onMSAzureSuccess = async (accessToken, idToken) => {
    // Do await and catch errors within the await to get most data and
    // allow for better error handling depending on error
    const { userServiceToken } = await exchangeToken(
      accessToken,
      "msazure"
    ).catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
      console.log(error.config);
    });
    if (userServiceToken !== null && userServiceToken !== undefined) {
      Cookie.set("agreedToPolicies", true, { expires: 365 });
      window.saveDataForWASM("msazure", idToken, accessToken, userServiceToken);
      localStorage.setItem("isFirstTimeLogin", false);
      props.setShowSignInPage(false);
    }
  };

  // ------------------------------------------------------------------------
  // Check whether the user is logged in or not and either show or hide the
  // the login modal
  const checkShouldDisplay = () => {
    let userLoggedIn;
    if (localStorage.getItem("userLoggedIn") === "true") {
      return "none";
    } else if (localStorage.getItem("msazurelogin") === "true") {
      return "none";
    } else {
      return "block";
    }
  };

  // ------------------------------------------------------------------------
  // Function to change the state of "hasChecked" that is used for checkbox
  // checked boolean
  const handleCheckedChange = (checked) => {
    setHasChecked(checked);
    setHasError(!checked);
  };
  const handleErrorChange = (checked) => {
    setHasChecked(!checked);
    setHasError(checked);
  };

  // ------------------------------------------------------------------------
  // Function that returns state of "hasChecked"
  const isChecked = () => {
    return hasChecked;
  };

  // ------------------------------------------------------------------------
  // Function that returns state of "hasError"
  const isError = () => {
    return hasError;
  };

  // ------------------------------------------------------------------------
  // Function that saves date selected by user
  const handleSelectedDateChange = (date) => {
    setSelectedDate(date);
  };

  // ------------------------------------------------------------------------
  // Function that saves valid age enum selected by user
  const handleValidAgeChange = (truefalse) => {
    setValidAge(truefalse);
  };

  // ------------------------------------------------------------------------
  // Age verifier function on submit with a cookie being added if user
  // entered correct age
  const verifyAge = () => {
    let currentDate = new Date();
    let birthdate = new Date(selectedDate);
    let diff = new Date(currentDate - birthdate);
    let age = Math.abs(diff.getUTCFullYear() - 1970);
    let isValid = age >= 13;
    let enums = ageEnum.unknown;
    if (isValid === true) {
      enums = ageEnum.valid;
    } else if (isValid === false) {
      enums = ageEnum.invalid;
    }

    Cookie.set("ageVerified", enums, { expires: 31536000, path: "/" });
    setValidAge(enums);
  };

  // ------------------------------------------------------------------------
  // Function to create a popup window
  const providerErrorPopup = (string) => {
    // Get the screen dimensions
    var screenW = window.screen.width;
    var screenH = window.screen.height;

    // Set the dimensions of the new window
    var winW = 640;
    var winH = 380;

    // Calculate the position for the new window to be centered
    var left = screenW / 2 - winW / 2;
    var top = screenH / 2 - winH / 2;

    // Open the new window
    var newWindow = window.open(
      "",
      "",
      `width=${winW},height=${winH},left=${left},top=${top}`
    );
    fetch(string)
      .then((response) => response.text())
      .then((data) => {
        newWindow.document.write(data);
      })
      .catch((error) => {
        console.error("Error fetching the HTML file:", error);
      });
  };

  // ------------------------------------------------------------------------
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "101%",
      height: "101%",
      maxWidth: "100%",
      transition: "all 5s ease",
      background: "rgba(195, 195, 195, 1)",
      display: `${checkShouldDisplay()}`,
    },
  };

  // ------------------------------------------------------------------------
  const checkboxPolicies = () => {
    const userAgreements = JSON.parse(sessionStorage.getItem("UserAgreements"));

    const myUserAgreements = userAgreements
      .filter((e) => e.Platforms.includes("W"))
      .map((e) => ({ Name: e.Name, URL: e.URL }));

    const policies = myUserAgreements
      .filter((e) => e.Name !== "Privacy Policy")
      .map((e, i, arr) => (
        <a
          key={e.Name} // Adding a unique key
          href=""
          onClick={(event) => {
            event.preventDefault();
            window.launchUrlPopup(e.URL);
          }}
        >
          {e.Name}
          {i !== arr.length - 1 ? ", " : ""}
          {/* {e.Name === "GDPR Data Retention Policy" && <br />} */}
        </a>
      ));

    const privacyPolicy = myUserAgreements
      .filter((e) => e.Name === "Privacy Policy")
      .map((e) => (
        <a
          key={e.Name}
          href=""
          onClick={(event) => {
            event.preventDefault();
            window.launchUrlPopup(e.URL);
          }}
        >
          {e.Name}
        </a>
      ));
    return (
      <span>
        I agree to the {policies} and {privacyPolicy}.
      </span>
    );
  };

  // ------------------------------------------------------------------------
  const invalidAgeNotice = () => {
    const userAgreements = JSON.parse(sessionStorage.getItem("UserAgreements"));

    const myUserAgreements = userAgreements
      .filter((e) => e.Platforms.includes("W"))
      .map((e) => ({ Name: e.Name, URL: e.URL }));

    const termsOfService = myUserAgreements
      .filter((e) => e.Name === "Terms of Service")
      .map((e) => (
        <a
          key={e.Name}
          href=""
          onClick={(event) => {
            event.preventDefault();
            window.launchUrlPopup(e.URL);
          }}
        >
          {e.Name}
        </a>
      ));

    return (
      <h3 className="invalid-message">
        Thank you for your interest in our services. Unfortunately, we are
        unable to process your access request at this time. For further details,
        please refer to our {termsOfService}.
      </h3>
    );
  };

  // ------------------------------------------------------------------------
  const ageGateNotice = () => {
    const userAgreements = JSON.parse(sessionStorage.getItem("UserAgreements"));

    const myUserAgreements = userAgreements
      .filter((e) => e.Platforms.includes("W"))
      .map((e) => ({ Name: e.Name, URL: e.URL }));

    const policies = myUserAgreements
      .filter((e) => e.Name !== "Privacy Policy")
      .map((e, i, arr) => (
        <a
          key={e.Name}
          href=""
          onClick={(event) => {
            event.preventDefault();
            window.launchUrlPopup(e.URL);
          }}
        >
          {e.Name}
          {i !== arr.length - 1 ? ", " : ""}
        </a>
      ));

    const privacyPolicy = myUserAgreements
      .filter((e) => e.Name === "Privacy Policy")
      .map((e) => (
        <a
          key={e.Name} // Adding a unique key
          href=""
          onClick={(event) => {
            event.preventDefault();
            window.launchUrlPopup(e.URL);
          }}
        >
          {e.Name}
        </a>
      ));

    const contactUs = (
      <a
        key={"Contact Us"} // Adding a unique key
        href=""
        onClick={(event) => {
          event.preventDefault();
          window.launchUrlPopup(supportLinks.support);
        }}
      >
        contact us
      </a>
    );
    return (
      <p>
        Your privacy and security are important to us. To comply with the
        Children's Online Privacy Protection Act (COPPA), we need to confirm
        your age before you can use our services. COPPA helps protect the online
        privacy and safety of individuals under the age of 13.
        <br />
        <br />
        By providing your birth date, you help us ensure that we're offering our
        services responsibly and in compliance with the law. We only use the
        information provided by you here to verify your age and will not use it
        for any other purposes.
        <br />
        <br />
        Thank you for your understanding and for helping us create a safe online
        environment for all users.
        <br />
        <br />
        For more information, please review our {policies} and {privacyPolicy}{" "}
        or feel free to {contactUs}.
        <br />
        <br />
        Please note: ClassLink, Clever & Google Workspace users should login
        directly via their SSO provider and launch the app from there.
      </p>
    );
  };

  // ------------------------------------------------------------------------
  // Helper function to hide part of H3 for small screens
  const checkSmallScreenSize = () => {
    const screenWidth = window.screen.availWidth;
    if (screenWidth < 400) {
      return false;
    } else if (screenWidth >= 400) {
      return true;
    }
  };
  // ------------------------------------------------------------------------
  // useEffect(() => {
  //   handleScreenSize();

  //   const orientationHandle = () => {
  //     if (window.orientation === 90 || window.orientation === -90) {
  //       // Landscape orientation
  //       alert("Please switch to portrait mode for the best experience.");
  //     }
  //   };
  //   window.addEventListener("resize", handleScreenSize);
  //   window.addEventListener("orientationchange", orientationHandle);
  //   return () => {
  //     window.removeEventListener("resize", handleScreenSize);
  //     window.removeEventListener("orientationchange", orientationHandle);
  //   };
  // }, []);

  // ------------------------------------------------------------------------
  return showHide ? (
    <div className="login-page">
      <div className="login-container">
        <div className="left-section">
          {/* <a href="https://www.ideamapper.com/"> */}
          <img
            src={IdeaMapperLogoWhite}
            alt="IdeaMapper Logo"
            className="logo"
          />
          {/* </a> */}
          <RotatingMessages />
        </div>

        <div className="right-section">
          <img
            src={IdeaMapperLogo}
            alt="IdeaMapper Logo"
            className="mobile-logo"
          />
          <div className="card">
            {props.configLoaded && props.loadFurther && (
              <>
                {isFirefox === true && (
                  <div className="firefox-warning">
                    <h2>
                      We sincerely apologize for any inconvenience this may
                      cause.
                      <br />
                      <br />
                      Unfortunately, IdeaMapper is not fully compatible with
                      Mozilla Firefox at the moment. To ensure a seamless
                      experience, we kindly recommend using an alternative web
                      browser for uninterrupted access.
                      <br />
                      <br />
                      Please rest assured that our team is actively working on
                      resolving this issue, and we truly appreciate your
                      patience and understanding.
                    </h2>
                  </div>
                )}

                {(validAge === ageEnum.valid || validAge === ageEnum.unknown) &&
                  !isFirefox && (
                    <div className="header">
                      {validAge === ageEnum.valid && (
                        <h3>
                          {isFirstTimeLogin ? "Welcome!" : "Welcome back!"}
                          <br></br>
                          {checkSmallScreenSize()
                            ? "Let’s get you signed in."
                            : ""}
                        </h3>
                      )}
                      {validAge === ageEnum.unknown && (
                        <h3>Please enter your birth date</h3>
                      )}
                    </div>
                  )}

                {validAge === ageEnum.unknown && !isFirefox && (
                  <div className="age-verification">
                    <div className="date-picker-container">
                      <DatePicker
                        value={selectedDate}
                        maxDate={new Date()}
                        format="dd/MM/yyyy"
                        required={true}
                        clearAriaLabel="Clear value"
                        clearIcon={null}
                        maxDeta="century"
                        yearPlaceholder="yyyy"
                        monthPlaceholder="mm"
                        dayPlaceholder="dd"
                        onChange={(date) => {
                          handleSelectedDateChange(date);
                        }}
                      />
                    </div>
                    <div className="submit-button-container">
                      <button
                        className="submit-button"
                        type="submit"
                        onClick={() => verifyAge()}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                )}

                {validAge === ageEnum.invalid && !isFirefox && (
                  <div className="message-container">{invalidAgeNotice()}</div>
                )}

                {validAge === ageEnum.unknown && !isFirefox && (
                  <div className="privacy-notice">{ageGateNotice()}</div>
                )}

                {validAge === ageEnum.valid && !isFirefox && (
                  <>
                    {/* .disabled-div start */}
                    <div
                      id="disabled"
                      className={`${isError() ? "disabled-div" : ""}`}
                      title=" "
                    >
                      <div
                        className={`signin_container ${
                          isError() ? "overlay_Gray" : ""
                        }`}
                      >
                        {/* <div className={`signin_container`}> */}
                        <div className="authenticator-container">
                          <AuthenticatorComponent
                            passBack={onCognitoSuccess}
                            setShowSignInPage={props.setShowSignInPage}
                            removePageLeaveEvent={props.removePageLeaveEvent}
                          />
                        </div>
                        <div className="sso-container">
                          <GoogleLoginButton
                            onGoogleSuccess={onGoogleSuccess}
                            setShowSignInPage={props.setShowSignInPage}
                            removePageLeaveEvent={props.removePageLeaveEvent}
                          />
                          <AzureAuthenticatorComponent
                            passBack={onMSAzureSuccess}
                            setShowSignInPage={props.setShowSignInPage}
                            removePageLeaveEvent={props.removePageLeaveEvent}
                          />
                          <div
                            className="clever-login"
                            title="Sign in with Clever"
                            onClick={() =>
                              providerErrorPopup("/cleverError.html")
                            }
                          >
                            <img
                              src={LogInWithClever}
                              alt="Login with Clever"
                            />
                          </div>
                          <div
                            className="classlink-login"
                            title="Sign in with Classlink"
                            onClick={() =>
                              providerErrorPopup("/classlinkError.html")
                            }
                          >
                            <img
                              src={LogInWithClassLink}
                              alt="Login with ClassLink"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* .disabled-div ending */}
                    <div className="checkbox-container">
                      <CheckboxField
                        className="terms-conditions-checkbox"
                        checked={hasChecked}
                        hasError={hasError}
                        name="acknowledgement"
                        value="yes"
                        label={checkboxPolicies()}
                        onChange={(e) => handleCheckedChange(e.target.checked)}
                      />
                    </div>
                  </>
                )}
              </>
            )}
            {!props.loadFurther && (
              <div className="session-detected">
                <h2>
                  We’ve detected an active session in another tab. Your map has
                  been successfully sent to that tab for your convenience.
                  <br />
                  <br />
                  You can safely close this tab now. Thank you!
                </h2>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default LoginComponent;
